Thématique choisie : {{ problematicTheme() ? problematicTheme() : 'non renseignée' }}<br>
Problématique formulée : {{ problematic() ? problematic() : 'non renseignée' }}<br>
